/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createEventEmitter, emitEvent } from "@adapptio/lib-shared";
import { MouseOrTouchEvent } from "@adapptio/lib-components";
import { TContextMenuId, TGetContextMenuParams } from "./contextMenuRegister";

interface IContextMenuShowParams<MenuId extends TContextMenuId = TContextMenuId> {
	id: MenuId;
	event: MouseOrTouchEvent;
	params: TGetContextMenuParams<MenuId>;
}

class ContextMenuManager {
	public onMenuOpen = createEventEmitter<IContextMenuShowParams>();
	public onHideAll = createEventEmitter();

	public showMenu(params: IContextMenuShowParams): void {
		this.hideAllMenus();
		emitEvent(this.onMenuOpen, params);
	}

	public hideAllMenus(): void {
		emitEvent(this.onHideAll);
	}
}

export const contextMenuManager = new ContextMenuManager();
